import {round} from "../round";

export function formatBodyMassInput(quantity) {
    return quantity ? String(round(quantity, 2)) : '';
}